import React from 'react';
import '../../styles/_Scroll.css';
import { Row } from "react-bootstrap";
import { NavLink } from 'react-router-dom';

const Scroll = () => {
    return (
        <Row id='scroll'>
            <div className='do-scroll'>
                <NavLink to={'/aboutme'}><div className='animated bounce scroll-transition'></div></NavLink>
            </div>
        </Row>
    )
}

export default Scroll;


// WEBPACK FOOTER //
// ./src/components/Home/Scroll.js